import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import CellRulesIcon from 'components/atoms/CellRulesIcon';
import React from 'react';
import CellRulePanelsContainer from '../../Pages/OperationsSettings/CellRulesDataGrid/CellRulePanelsContainer';

interface CellRuleStudySettingsProps {
  studyId: string;
  editable?: boolean;
}

const CellRuleStudySettings: React.FC<CellRuleStudySettingsProps> = ({ studyId, editable = false }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', columnGap: 1 }}>
          <CellRulesIcon color="action" />
          <Typography variant="h3">Cell Rules</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <CellRulePanelsContainer studyId={studyId} editable={editable} />
      </AccordionDetails>
    </Accordion>
  );
};

export default CellRuleStudySettings;
